Core.Carousels = function () {
    if (Core.Cache.$carousels) {

        var _self = this,
            updateLayout = Core.Util.Debounce(function () {
                _self._init(true);
            }, 400);

        Core.Cache.$window.on('resize', function() {
            updateLayout();
        });

        _self._init(false);
    }
};

Core.Carousels.prototype = {
    constructor: Core.Engine.Carousels,
    _init: function (changeSettings) {
        var _config = Core.Config.Carousel;

        if (!changeSettings) {
            this.DisplayMode = this._setDisplayMode();
            this.CarouselSlideWidth = '';
            this.Objects = [];
        }

        for (var x = 0; x < Core.Cache.$carousels.length; x++) {
            var $this = Core.Cache.$carousels.eq(x),
                parentWidth = $this.closest('.block').width(),
                slideMargin = _config.DesktopSlideMargin,
                maxSlides = $this.data('max-slides'),
                auto = $this.data('auto'),
                moveSlides = $this.data('move-slides');

            if (Core.IsMobile()) {
                this.CarouselSlideWidth = parentWidth;
                slideMargin = _config.MobileSlideMargin;
                maxSlides = $this.data('mobile-max-slides') || _config.MobileSlideCount;
            }

            if (!changeSettings) {
                if (!Core.IsMobile()) {
                    this.CarouselSlideWidth = (parentWidth / maxSlides) - slideMargin;
                }
                this.Objects[x] = $this.bxSlider({
                    pager: _config.Pager,
                    auto: auto,
                    speed: _config.Speed,
                    pause: _config.Pause,
                    autoHover: _config.PauseOnHover,
                    infiniteLoop: _config.InfiniteLoop,
                    hideControlOnEnd: _config.HideControlOnEnd,
                    useCSS: false,
                    slideWidth: this.CarouselSlideWidth,
                    minSlides: maxSlides,
                    maxSlides: maxSlides,
                    moveSlides: moveSlides,
                    slideMargin: slideMargin
                });
            }
            else {
                if ((this.DisplayMode === "mobile" && !Core.IsMobile()) || (this.DisplayMode === "desktop" && Core.IsMobile())) {
                    this.Objects[x].reloadSlider({
                        pager: _config.Pager,
                        auto: auto,
                        speed: _config.Speed,
                        pause: _config.Pause,
                        autoHover: _config.PauseOnHover,
                        infiniteLoop: _config.InfiniteLoop,
                        hideControlOnEnd: _config.HideControlOnEnd,
                        useCSS: false,
                        slideWidth: this.CarouselSlideWidth,
                        minSlides: maxSlides,
                        maxSlides: maxSlides,
                        moveSlides: moveSlides,
                        slideMargin: slideMargin
                    });
                }
            }
        }

        if ($('.carousel > li').not('.bx-clone').length < 4){
            $('.bx-controls').hide();
        }

        this.DisplayMode = this._setDisplayMode();
    },
    _setDisplayMode: function () {
        if (Core.IsMobile()) {
            return "mobile";
        }
        else {
            return "desktop";
        }
    }
};
